import { action } from '../../../appLogic/appActions';

export const ADD_REVIEW = action('ADD_REVIEW');
